import styled from 'styled-components';
export const ButtonFlexRowStyled = styled('button') `
  flex-direction: row;
`;
